module.exports = __webpack_public_path__ + "media/1.fdee0cbb.wav";